import Utils from '@/utils/default'
import http, { endpoint } from '@/utils/http'
import io from 'socket.io-client'

const ChatDetails = {
  socket: null,
  user: null
}

const init = userId => new Promise((resolve, reject) => {
  ChatDetails.user = userId
  ChatDetails.socket = io(endpoint(process.env.CHAT_ENDPOINT_PREFIX, { protocol: 'wss' }), {
    transports: ['websocket'],
    query: `user=${userId}`
  })
  ChatDetails.socket.on('connect', () => resolve(ChatDetails.socket))
  ChatDetails.socket.on('disconnect', () => (ChatDetails.socket = null))
  ChatDetails.socket.on('error', error => reject(error))
})

const fetchConversations = ({ userId, page = 1 }) => http(endpoint(process.env.CHAT_ENDPOINT_PREFIX))
  .get(`/users/${userId}/conversations?${Utils.dataToUrlString({ page })}`)

const fetchConversation = ({ id }) => http(endpoint(process.env.CHAT_ENDPOINT_PREFIX))
  .get(`/conversations/${id}`)

const fetchPending = ({ userId }) => http(endpoint(process.env.CHAT_ENDPOINT_PREFIX))
  .get(`/pendings?${Utils.dataToUrlString({ user: userId })}`)

const messages = ({ conversationId, page = 1 }) => http(endpoint(process.env.CHAT_ENDPOINT_PREFIX))
  .get(`/conversations/${conversationId}/messages?${Utils.dataToUrlString({ page })}`)

const markAsRead = ({ ids, readAt, user }) => ids.length ? http(endpoint(process.env.CHAT_ENDPOINT_PREFIX))
  .post(`/read`, { ids, readAt, user }) : Promise.resolve()

const markAsReceived = ({ id, receivedAt, user }) => http(endpoint(process.env.CHAT_ENDPOINT_PREFIX))
  .put(`/messages/${id}`, { receivedAt, user })

const sendMessage = ({ content, from, query, data, conversationId }) => {
  if (conversationId) {
    return http(endpoint(process.env.CHAT_ENDPOINT_PREFIX))
      .post(`/conversations/${conversationId}/messages`, {
        from,
        content,
        data
      })
  } else {
    return http(endpoint(process.env.CHAT_ENDPOINT_PREFIX))
      .post(`/messages`, {
        from,
        query,
        content,
        data,
        sentAt: new Date()
      })
  }
}

const findConversation = ({ from, to }) => http(endpoint(process.env.CHAT_ENDPOINT_PREFIX))
  .post(`/conversations/search`, { from, to })

export default {
  init,
  fetchConversations,
  fetchConversation,
  findConversation,
  fetchPending,
  sendMessage,
  messages,
  markAsRead,
  markAsReceived,
  ChatDetails
}



// WEBPACK FOOTER //
// ./src/api/messenger.js